import {
  Brain, Cpu, Network, MessageSquare, BookOpen, Sparkles, Bot, Wand2,
  Image as ImageIcon, Video, Code, Blocks, Workflow, Database, Briefcase,
  Terminal, Rocket, GraduationCap, Music, Megaphone, PenTool, BarChart3,
  FlaskConical, Palette, TrendingUp, Scale, HeartPulse, Package,
  Zap, Star, DollarSign, Calendar, Mail, FileText, Newspaper,
} from "lucide-react";

export const iconMap = {
  brain: Brain,
  cpu: Cpu,
  network: Network,
  "message-square": MessageSquare,
  "book-open": BookOpen,
  sparkles: Sparkles,
  bot: Bot,
  "wand-2": Wand2,
  image: ImageIcon,
  video: Video,
  code: Code,
  blocks: Blocks,
  workflow: Workflow,
  database: Database,
  briefcase: Briefcase,
  terminal: Terminal,
  rocket: Rocket,
  "graduation-cap": GraduationCap,
  music: Music,
  megaphone: Megaphone,
  "pen-tool": PenTool,
  "bar-chart": BarChart3,
  flask: FlaskConical,
  palette: Palette,
  "trending-up": TrendingUp,
  scale: Scale,
  "heart-pulse": HeartPulse,
  package: Package,
  zap: Zap,
  star: Star,
  "dollar-sign": DollarSign,
  calendar: Calendar,
  mail: Mail,
  "file-text": FileText,
  newspaper: Newspaper,
};

export function getIcon(name) {
  return iconMap[name] || Sparkles;
}
